var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.task.negotiableDuration)?[_vm._v("\n    "+_vm._s(_vm.task.duration)+" "+_vm._s(_vm.$t('tasks.details.days'))+"\n  ")]:[_vm._v("\n    "+_vm._s(_vm.$t('tasks.details.negotiable'))+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }